"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatList = exports.Stat = exports.StatItem = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var flexbox_1 = require("../flexbox");
var padding_1 = require("../padding");
var text_1 = require("../text");
function StatItem(props) {
    var label = props.label, children = props.children;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(padding_1.Padding, { bottom: 4 },
            react_1.default.createElement(text_1.Text, { color: "light", size: "small" }, label)),
        react_1.default.createElement(StyledValue, null, children)));
}
exports.StatItem = StatItem;
function Stat(props) {
    var children = props.children, label = props.label;
    return (react_1.default.createElement(StyledBox, null,
        react_1.default.createElement(padding_1.Padding, { y: 4, right: 8 },
            react_1.default.createElement(StatItem, { label: label }, children))));
}
exports.Stat = Stat;
function StatList(props) {
    var children = props.children;
    return (react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "flex-start", flexDirection: "row" }, children));
}
exports.StatList = StatList;
var StyledValue = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  align-items: center;\n  height: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  height: 20px;\n"])));
var StyledBox = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  border-left: 1px solid ", ";\n  padding: 0 8px 0 8px;\n  height: 48px;\n\n  > div {\n    padding-left: 8px;\n  }\n\n  &:first-child {\n    border: none;\n    padding-left: 0;\n\n    > div {\n      padding-left: 0px;\n    }\n  }\n"], ["\n  border-left: 1px solid ", ";\n  padding: 0 8px 0 8px;\n  height: 48px;\n\n  > div {\n    padding-left: 8px;\n  }\n\n  &:first-child {\n    border: none;\n    padding-left: 0;\n\n    > div {\n      padding-left: 0px;\n    }\n  }\n"])), theme_1.colors.gray_xl);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map